// Motion preference for the two things CSS cannot govern: script-driven
// scrolling (`scrollIntoView({behavior})`) is not covered by the
// `prefers-reduced-motion` media query, so a reduced-motion user still got an
// animated scroll on the import preview and the training check (review A-11).
// Pure over an injectable window so it tests without a browser.

/**
 * Does this browser ask for reduced motion? False when it cannot say.
 * @param {any} [win] defaults to globalThis
 * @returns {boolean}
 */
export function prefersReducedMotion(win) {
  const w = win || /** @type {any} */ (globalThis);
  try {
    return !!(w && typeof w.matchMedia === 'function' && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch {
    return false;
  }
}

/**
 * The `behavior` to pass to scrollIntoView(): 'auto' (instant) for a
 * reduced-motion user, 'smooth' otherwise.
 * @param {any} [win]
 * @returns {'auto'|'smooth'}
 */
export function scrollBehavior(win) {
  return prefersReducedMotion(win) ? 'auto' : 'smooth';
}
